   /* eslint-disable */
 <template>

 <div>

  <v-sheet class="pa-5">

          <v-btn @click="resetar"   text icon color="green">
                <v-icon>cached</v-icon>
            </v-btn>

    <v-list>
      <v-list-item
        v-for="item in abertInsts"
        :key="item.descricao"

      >

        <v-list-item-content>
  <v-col cols="12" sm="12" md="12">
           <v-switch  v-model="item.status_2" @change="save(item)"  :label="item.descricao"></v-switch>
      <span style="color:gray; font-size:12px;margin-left:20px">     {{ item.autor}} </span>  <br>  <br>     <span style="color:gray; font-size:12px;margin-left:20px">  {{ item.data_2}} </span>
  </v-col>

        </v-list-item-content>

      </v-list-item>
    </v-list>
  </v-sheet>

 </div>

</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({
    abertInsts: [],
    descricao: '',
    status_2: false,

    editedItem: {
      idaberturafechoinstituicao: 0,
      descricao: '',
      status_2: false

    }

  }),
  created () {
    this.initialize()
    // check if classe has been selected otherwise send back to painel to select
  },

  computed: {

  },

  methods: {
    resetar () {
      confirm('Tem certez que quer redefinir as configuracoes de Abertura e fecho ?') &&
        this.aberfechotInstituicaoReset()
    },

    async   save (item) {
      this.editedItem = item
      const ls = require('local-storage')
      var params = {
        id: item.idaberturafechoinstituicao,
        status: !item.status_2,
        autor: ls.get('nomeUsuario')
      }

      try {
        let msg = await axios
          .post('/aberfechotInstituicaoUpdate', params)
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.CarregActividades()
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        try {
          if (msg.affectedRows >= 1) {
            this.text = msg.affectedRows + ' gravado(s) com sucesso'
            this.$store.dispatch('textMessage', {
              msg: this.text,
              classMessage: 'msgSucess',
              timeout: 2000
            })
          }
        } catch (error) {}
      } catch (error) {
        console.log('eroooo: ' + error)
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      } finally {
        this.initialize()
      }
    },

    async CarregActividades () {
      try {
        this.$store.state.actividades = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log(this.$store.state.actividades)
      } catch (error) {

      }
    },

    async initialize () {
      try {
        this.abertInsts = await axios
          .get('/listAberturaFechoInstituicao')
          .then(res => res.data)
        console.log('passou--------------------------------')
      } catch (error) {
        this.isLoading = false
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    //

    async aberfechotInstituicaoReset () {
      try {
        let msg = await axios
          .post('/aberfechotInstituicaoReset')
          .then(res => res.data)
          // this.text = msg[1].insertId
        this.text = msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 2000
        })
        this.initialize()
      } catch (error) {

      }
    }

  }

}

</script>
